import { colors, Skeleton, styled, TableCell, TableRow } from "@mui/material";
import { tableCellClasses } from '@mui/material/TableCell';
import { tableRowClasses } from '@mui/material/TableRow';
import { Fragment, useEffect, useRef, useState } from "react";


export default function TableRatesRow({ planName, planLabel, clients, bgColor = colors.grey[100], loading, rates, currency, visible = true, additionalColumns = [], planLabelColSpan = 1, planLabelFontSize = null, discount = 0, additionalLoading = 0, fractionDigits = 2, labelWidth = 260 }) {
  const tableRowRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    if (!tableRowRef) return;

    const parentTable = tableRowRef?.current?.closest('table');

    if (parentTable) {
      // Select all TableRow elements inside the TableBody
      const rows = document.querySelectorAll('#' + parentTable.id + ' .MuiTableBody-root .MuiTableRow-root');

      // Calculate the maximum height
      let max = 0;
      rows.forEach(row => {
        const height = row.offsetHeight;
        if (height > max) {
          max = height;
        }
      });

      setMaxHeight(max);
    }
  }, [rates]);

  // function generateKey(client, index) {
  //   if (client == null) { return; }

  //   const name = client.name || '';
  //   const age = String(client.age || '');
  //   const idx = String(index || '');
  //   return name + age + idx;
  // }

  function formatRate(rate) {
    if (isNaN(rate) || rate == 'Unavailable' || typeof rate === 'string') {
      return <span style={{ color: '#f44336' }}>{'Unavailable'}</span>
    }

    if (isNaN(rate)) {
      return rate;
    }

    return getCurrencySign() + rate.toLocaleString('en-PH', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits });
  }

  function getCurrencySign() {
    const currency = getCurrency();

    if (currency === 'USD') {
      return '$';
    } else if (currency === 'EURO') {
      return '€';
    } else if (currency === 'GBP') {
      return '£';
    } else if (currency === 'SGD') {
      return 'S$';
    } else if (currency === 'AUD') {
      return 'AU$';
    }

    return '';
  }

  function getCurrency() {
    if (rates == null) { return '' }

    if (rates.length === 0) { return '' }

    return rates[0].currency;
  }

  function computeRatesSubtotal(field) {
    if (rates == null) { return; }

    let total = 0;

    for (let i = 0; i < rates.length; i++) {
      if (isNaN(rates[i][field])) {
        return 0;
      }

      total += rates[i][field];
    }

    // const totalPercent = (100 - discount) * 0.01;
    discount = parseFloat(discount) || 0;
    additionalLoading = parseFloat(additionalLoading) || 0;

    const totalPercent = ((100 - discount + additionalLoading) * 0.01);

    return total * totalPercent;
  }

  function computedRate(clientRate, planName) {
    // const totalPercent = (100 - discount) * 0.01;
    discount = parseFloat(discount) || 0;
    additionalLoading = parseFloat(additionalLoading) || 0;

    const totalPercent = ((100 - discount + additionalLoading) * 0.01);

    return clientRate[planName] * totalPercent;
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
      border: '2px solid #fff',
      backgroundColor: colors.grey[100],
      height: maxHeight
    },
  }));

  const styleObj = {
    border: '2px solid #fff',
    backgroundColor: colors.grey[100],
    height: maxHeight
  }




  return (
    <Fragment>
      {
        visible ?
          <TableRow ref={tableRowRef} style={{ display: visible === true ? 'table-row' : 'none' }}>

            <TableCell style={{ ...styleObj, background: bgColor, fontSize: planLabelFontSize, width: labelWidth, minWidth: labelWidth }} colSpan={planLabelColSpan}>{planLabel}</TableCell>

            {
              loading ? (additionalColumns.map((additionalColumn, index) => {
                return <TableCell style={{ ...styleObj, background: additionalColumn.bgColor ? additionalColumn.bgColor : bgColor}} key={additionalColumn.value + index}><Skeleton variant="rounded" width={45} height={20} /></TableCell>
              })) :
                (additionalColumns.map((additionalColumn, index) => {
                  return <TableCell key={additionalColumn.value + index} style={{ ...styleObj, background: additionalColumn.bgColor ? additionalColumn.bgColor : bgColor, textAlign: additionalColumn.textAlign }}>{additionalColumn.value}</TableCell>
                }))
            }

            {
              loading ?
                (
                  clients.map((client, index) => {
                    return <TableCell style={{ ...styleObj }} key={client.uid}><Skeleton variant="rounded" width={100} height={20} /></TableCell>
                  })) :
                (rates.map((client_rate, index) => {
                  return <TableCell style={{ ...styleObj }} key={client_rate.uid}>{formatRate(computedRate(client_rate, planName))}</TableCell>
                }))
            }
            <TableCell style={{ ...styleObj }}>{loading ? <Skeleton variant="rounded" width={100} height={20} /> :
              formatRate(computeRatesSubtotal(planName))}</TableCell>
          </TableRow>
          : <Fragment />}
    </Fragment>
  );
}